import { opthomologyInternal } from "./opthomology-internal";
import { orthoInternal } from "./ortho-internal";
import { pediatricsInternal } from "./pediatrics-internal";
import { gynoInternal } from "./gyno-internal";
import { general } from "./otherInternal";

export const departmentinternal = {
  opthomology: opthomologyInternal,
  ophthalmology: opthomologyInternal,
  ortho: orthoInternal,
  pediatrics: pediatricsInternal,
  gyno: gynoInternal,
  general: general,
};
